import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const INSTAGRAM = 'https://www.instagram.com/the_listing_room';

export default function SiteFooter() {
  return (
    <footer style={{ backgroundColor: '#0A0A0A', color: '#fff', paddingTop: '4rem', paddingBottom: '2rem' }}>
      <div className="container-app">
        <div className="grid md:grid-cols-4 gap-10 pb-12">
          <div className="md:col-span-2">
            <span className="text-2xl font-bold tracking-tight">The Listing Room</span>
            <p className="text-sm mt-4 mb-6 text-white/50" style={{ maxWidth: '340px' }}>
              A peer-to-peer members platform for buying and selling art with 0% commission.
            </p>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center w-10 h-10 transition-colors hover:bg-white hover:text-black" style={{ border: '1px solid rgba(255,255,255,0.25)' }}>
              <Instagram size={16} />
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] mb-5 text-white/40">Quick Links</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/about" className="editorial-link">About</Link></li>
              <li><Link to="/guide" className="editorial-link">Guide</Link></li>
              <li><Link to="/browse" className="editorial-link">Browse</Link></li>
              <li><Link to="/register" className="editorial-link">Become a Member</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] mb-5 text-white/40">Support</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/privacy" className="editorial-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="editorial-link">Terms of Service</Link></li>
              <li><Link to="/login" className="editorial-link">Login</Link></li>
            </ul>
          </div>
        </div>
        <div className="pt-6 text-xs text-white/40" style={{ borderTop: '1px solid rgba(255,255,255,0.12)' }}>
          © {new Date().getFullYear()} The Listing Room. All rights reserved. Operated by Messums ORG.
        </div>
      </div>
    </footer>
  );
}
